import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useStores } from "../../../store";
import { __, _i } from "../../../utils";
import { Badge, Spin, Tag } from "antd";
const HREF_SETTINGS = "#/settings";
const HREF_COOKIES = "#/cookies";
const HREF_TCF_VENDORS = "#/cookies/tcf-vendors";
const DashboardGeneralCardContent = observer(()=>{
    const { optionStore, cookieStore: { groups } } = useStores();
    const { isTcf, isBannerActive, isBlockerActive, busySettings, cookieCounts, isOnlyRcbCookieCreated, tcfVendorConfigurationCounts } = optionStore;
    const useBlockerActive = isBannerActive && isBlockerActive;
    return /*#__PURE__*/ _jsxs(Spin, {
        spinning: groups.busy || busySettings,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Badge, {
                        status: isBannerActive ? "success" : "error",
                        text: _i(isBannerActive ? __("Cookie Banner is {{strong}}activated{{/strong}}") : __("Cookie Banner is {{strong}}deactivated{{/strong}}"), {
                            strong: /*#__PURE__*/ _jsx("strong", {})
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: _i(__("You can enable and disable the cookie banner in the {{a}}settings page{{/a}}."), {
                            a: /*#__PURE__*/ _jsx("a", {
                                href: HREF_SETTINGS
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Badge, {
                        status: useBlockerActive ? "success" : "error",
                        text: _i(useBlockerActive ? __("Content Blocker is {{strong}}activated{{/strong}}") : __("Content Blocker is {{strong}}deactivated{{/strong}}"), {
                            strong: /*#__PURE__*/ _jsx("strong", {})
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: _i(__("You can enable and disable the content blocker in the {{a}}settings page{{/a}}."), {
                            a: /*#__PURE__*/ _jsx("a", {
                                href: HREF_SETTINGS
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    __("Available service groups:"),
                    " ",
                    groups.sortedGroups.map((param)=>{
                        let { data: { name, id } } = param;
                        return /*#__PURE__*/ _jsx(Tag, {
                            children: name
                        }, id);
                    }),
                    "•\xa0",
                    /*#__PURE__*/ _jsx("a", {
                        href: HREF_COOKIES,
                        children: __("Manage")
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    _i(__("You have defined {{strong}}%d enabled{{/strong}}, %d disabled and %d draft services.", isOnlyRcbCookieCreated ? 0 : cookieCounts.publish, isOnlyRcbCookieCreated ? 0 : cookieCounts.private, isOnlyRcbCookieCreated ? 0 : cookieCounts.draft), {
                        strong: /*#__PURE__*/ _jsx("strong", {})
                    }),
                    "\xa0\xa0•\xa0\xa0",
                    /*#__PURE__*/ _jsx("a", {
                        href: HREF_COOKIES,
                        children: __("Manage")
                    })
                ]
            }),
            isTcf && tcfVendorConfigurationCounts && /*#__PURE__*/ _jsxs("p", {
                children: [
                    _i(__("You have defined {{strong}}%d enabled{{/strong}}, %d disabled and %d draft TCF vendors.", tcfVendorConfigurationCounts.publish, tcfVendorConfigurationCounts.draft, tcfVendorConfigurationCounts.private), {
                        strong: /*#__PURE__*/ _jsx("strong", {})
                    }),
                    "\xa0\xa0•\xa0\xa0",
                    /*#__PURE__*/ _jsx("a", {
                        href: HREF_TCF_VENDORS,
                        children: __("Manage")
                    })
                ]
            })
        ]
    });
});
export { DashboardGeneralCardContent };
